import React from "react";
import OTPChangePhone from "../../../components/section-components/registration/otpChangePhone";

const WLOTPChangePhone = (props) => {
  return (<OTPChangePhone />);
};

export default WLOTPChangePhone;
